import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import RequestMessages from '~/components/shared/RequestMessages';
import ServiceRequestContext from '../context';
const MessagesTab = ({focused}) => {
  const {damage_id, overview} = useContext(ServiceRequestContext);
  return (
    <RequestMessages
      focused={focused}
      request_id={damage_id}
      overview={overview}
    />
  );
};
MessagesTab.propTypes = {focused: PropTypes.any};
export default MessagesTab;
